// Реальный клиент: отправляет форму на наш API через nginx proxy (/api/booking)
class ApiClient {
  static #instance;
  static getInstance() { if (!ApiClient.#instance) ApiClient.#instance = new ApiClient(); return ApiClient.#instance; }

  async submitBooking(payload) {
    const res = await fetch('/api/booking', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const t = await res.text().catch(()=> '');
      throw new Error(`Booking failed: ${res.status} ${t}`);
    }

    const data = await res.json().catch(()=> ({}));
    if (data && typeof data === 'object') return data;
    return { ok: true };
  }
}
export default ApiClient.getInstance();
